import {getCookieId, removeCookieId} from './globalUserId';
import {user} from './user';
import {checkSess} from './session';

export async function userLoad() {
  await getCookieId();
  // 如果session存在，验证是否有效
  if (user.session) {
    checkSess();
  }
  // 为了同步
  return new Promise(resolve => {
    resolve(user);
  });
}

export {
  user,
  getCookieId, removeCookieId
};